import {Component, OnInit} from '@angular/core';
import {ReporteServices} from '../services/reporte.services';
import {NgxSpinnerService} from 'ngx-spinner';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {TypeaheadMatch} from 'ngx-bootstrap';
import * as moment from 'moment';
import {RegionalEntity} from '../../CoreModule/entities/regional.entity';
import {RegionalServices} from '../../CoreModule/services/regional.services';
import {UsuarioServices} from '../../CoreModule/services/usuario.services';
import {UsuarioEntity} from '../../CoreModule/entities/usuario.entity';

@Component({
  selector:"reporte-marca-col",
  templateUrl:"../templates/reporte.marcas.regional.template.html"
})
export class ReporteMarcasRegionalComponent implements OnInit{

  opcSem: any[] = [];
  public semSelect: number;
  public mesSelect: number;
  public trimSelect: number;
  public semesSelect: number;
  public anoSelect: number = 2019;
  public userSelect: UsuarioEntity;


  public regionalSelect: RegionalEntity;


  public regionales: RegionalEntity[] = [];
  public userReg: UsuarioEntity[] = [];

  public verSec: number = 0;
  user: any;

  public tiendas: TiendaEntity[] = [];
  public tiendaSelect: TiendaEntity;
  public tSelectName: string = '';

  public fecha1: string;
  public fecha2: string;

  public tituloReport: string = '';

  public dtPart: any[] = [];



  constructor(private rs: ReporteServices, private spinner: NgxSpinnerService, private regs: RegionalServices, private us:UsuarioServices){
    for (let j = 1; j < 53; j++) {
      this.opcSem.push(j);
    }
  }

  ngOnInit(): void {
    this.spinner.show()
    this.regs.getAllRegional().subscribe(d => {
      this.regionales = d.data.regionales;

    });

    this.us.getAllUser().subscribe(d => {


      this.userReg = d.data.usuarios.filter((u) => {
        return u.rol.id == 5;
      });

      this.userReg.map((u)=>{
        u.nombreCompleto = u.nombres + " " + u.apellidos;
      })
      this.spinner.hide();
    });
  }

  usuarioSeleccionado(event: TypeaheadMatch) {
    this.userSelect = event.item;
  }

  consultarDatos() {
    this.verSec = 0;
    this.dtPart = [];

    this.spinner.show();

    if (this.userSelect) {
      let fechaIni = moment(this.fecha1);
      let fechaFin = moment(this.fecha2);

      this.tituloReport = `Reporte de Marcas x Regional (Top 5) del ${fechaIni.format('DD-MM-YYYY')} al ${fechaFin.format('DD-MM-YYYY')}`;

      this.rs.devolverReporteMixVentaParticipantes(3, this.userSelect.id.toString(), fechaIni.format('YYYY-MM-DD'), fechaFin.format('YYYY-MM-DD')).subscribe(d => {
        this.spinner.hide();

        let jDt = JSON.parse(d.data.reporteMixVentasParticipantes);

        for(let p of jDt){
          let par:any = {};
          par.participante = p.participante;
          par.comprobarVentas = p.comprobarVentas;
          par.info = this.clasificarXCategoria(p.ventas);
          this.dtPart.push(par);
        }

      });
    }
  }

  clasificarXCategoria(datos: any) {
    let dtCat:any[] = [];
    for (let d of datos) {
      let cat = dtCat.find(c => d.categoria == c.categoria);

      if (cat) {
        cat.valor += d.valor;

        let m = cat.marcas.find(_m => _m.marca == d.marca);
        if (m) {
          m.valor += d.valor;
          m.cantidad++;
        } else {
          cat.marcas.push({
            marca: d.marca,
            valor: d.valor,
            cantidad: 1
          });
        }

      } else {

        let newCat: any = {
          categoria: d.categoria,
          valor: d.valor,
          marcas: []
        };

        newCat.marcas.push({
          marca: d.marca,
          valor: d.valor,
          cantidad: 1
        });

        dtCat.push(newCat);
      }
    }

    return this.ordenarCategorias(dtCat);
  }

  ordenarCategorias(dtCat:any[]) {
    dtCat.sort((a, b) => {
      if (a.categoria > b.categoria)
        return 1;
      else
        return -1;
    });

    dtCat.map(c => {

      c.marcas.map(m => {
        m.porcentaje = m.valor / c.valor * 100;
      });

      c.marcas.sort((a, b) => {
        if (a.porcentaje < b.porcentaje)
          return 1;
        if (a.porcentaje > b.porcentaje)
          return -1;

        return 0;
      });

      // para sacar solo el top 5
      c.marcas = c.marcas.slice(0, 5);

    });

    // dtCat.map(c => {
    //     let dt: any = {
    //       categoria: c.categoria,
    //       marcas: []
    //     };
    //
    //     c.marcas.map(m => {
    //       dt.marcas.push({
    //         name: m.marca,
    //         value: m.valor,
    //         extra:{
    //           code:"co"
    //         }
    //       });
    //     });
    //
    //     // this.dtTreeCat.push(dt);
    //   }
    // );

    return dtCat;
  }


  consultarSemana() {
    if (this.verSec != 0) {
      this.verSec = 0;
      return;
    }

    let dia1 = moment();
    // let dia2 = moment();
    this.fecha1 = dia1.day(1).format('YYYY-MM-DD');
    this.fecha2 = moment(dia1).add(7, 'd').format('YYYY-MM-DD');
    this.consultarDatos();
  }

  consultarMes() {
    if (this.verSec != 0) {
      this.verSec = 0;
      return;
    }

    let dia1 = moment();
    let dia2 = moment();
    this.fecha1 = dia1.date(1).format('YYYY-MM-DD');
    dia2.date(1).add(1,'M').subtract(1,'d');
    this.fecha2 = dia2.format('YYYY-MM-DD');
    this.consultarDatos();
  }

  consultarTrimestre() {
    if (this.verSec != 2) {
      this.verSec = 2;
      return;
    }

    if (this.anoSelect == undefined) {
      alert('Ingrese un año');
      return;
    }

    let opc = +this.trimSelect;

    switch (opc) {
      case 1:
        this.fecha1 = `${this.anoSelect}-01-01`;
        this.fecha2 = `${this.anoSelect}-03-31`;

        break;
      case 2:
        this.fecha1 = `${this.anoSelect}-04-01`;
        this.fecha2 = `${this.anoSelect}-06-30`;
        break;
      case 3:
        this.fecha1 = `${this.anoSelect}-07-01`;
        this.fecha2 = `${this.anoSelect}-09-30`;
        break;
      case 4:
        this.fecha1 = `${this.anoSelect}-10-01`;
        this.fecha2 = `${this.anoSelect}-12-31`;
        break;

    }

    this.consultarDatos();
  }

  consultarSemestre() {
    if (this.verSec != 3) {
      this.verSec = 3;
      return;
    }
    if (this.anoSelect == undefined) {
      alert('Ingrese un año');
      return;
    }

    let opc = +this.semesSelect;

    switch (opc) {
      case 1:
        this.fecha1 = `${this.anoSelect}-01-01`;
        this.fecha2 = `${this.anoSelect}-06-30`;
        break;
      case 2:
        this.fecha1 = `${this.anoSelect}-07-01`;
        this.fecha2 = `${this.anoSelect}-12-31`;
        break;
    }

    this.consultarDatos();
  }

  consultarAnual() {
    if (this.verSec != 4) {
      this.verSec = 4;
      return;
    }
    if (this.anoSelect == undefined) {
      alert('Ingrese un año');
      return;
    }
    this.fecha1 = `${this.anoSelect}-01-01`;
    this.fecha2 = this.fecha2 = `${this.anoSelect}-12-31`;

    this.consultarDatos();
  }

  consultarFechas() {
    this.verSec = 1;
  }

  consultarHoy() {
    if (this.verSec != 0) {
      this.verSec = 0;
      return;
    }

    let dia1 = moment();
    let dia2 = moment();
    this.fecha1 = dia1.format('YYYY-MM-DD');
    this.fecha2 = dia2.format('YYYY-MM-DD');
    this.consultarDatos();
  }

}
